// Error codes returned by api-auth-gateway (see its README "Error codes"). Match on `code`;
// the message text is kept stable by the gateway, but the code is the contract.
//   GWA003 missing token · GWA004 bad/expired token · GWA005 wrong MPIN · GWA006 locked
//   GWB001 IP changed → MPIN re-auth · GWB002 token revoked → log in again
//   GWC002 crypto session expired

export const SESSION_EXPIRED_MESSAGE = "Session expired or invalid";

export function errorCodeOf(err) {
  return err?.response?.data?.code;
}

export function isSessionExpired(err) {
  return (
    errorCodeOf(err) === "GWC002" ||
    (err?.response?.status === 401 && err?.response?.data?.message === SESSION_EXPIRED_MESSAGE)
  );
}

// "Account locked. Try again in 15 minutes." → 900. Falls back to the gateway's default 15 minutes.
function lockoutSecondsFrom(message = "") {
  const m = /(\d+)\s*(minute|second)/i.exec(message);
  if (!m) return 900;
  const n = parseInt(m[1], 10);
  return /minute/i.test(m[2]) ? n * 60 : n;
}

// What the MPIN screen should do with a failed unlock / re-auth call.
export function describeMpinError(err) {
  const message = err?.response?.data?.message;
  if (isSessionExpired(err)) return { action: "resession" };
  switch (errorCodeOf(err)) {
    case "GWA005":
      return { action: "retry", message: "Invalid MPIN." };
    case "GWA006":
      return { action: "locked", message, lockoutSeconds: lockoutSecondsFrom(message) };
    case "GWB002":
    case "GWA003":
    case "GWA004":
      return { action: "logout", message: "Your session is no longer valid. Please log in again." };
    default:
      return { action: "retry", message: message || "Something went wrong. Please try again." };
  }
}
